<ng-container *ngIf="!!hubState; else loading">
  <div><label class="left">last seen: </label><span [class]="lastSeenClass()">{{hubState.last_seen | godate}}</span>
  </div>
  <div><label class="left">heating: </label>{{heatingStateDescription}}</div>
  <div><label class="left">mV/wires<ng-container *ngIf="SameOrNewerThan(0,9,18)">/pwr</ng-container>:
    </label>{{hubState.battery_level}} / {{hub.wires}}
    <ng-container *ngIf="SameOrNewerThan(0,9,18)"> /
      <ng-container *ngIf="hubState.mains; else unpowered">Powered</ng-container>
      <ng-template #unpowered><span class="warn">Unpowered</span></ng-template>
    </ng-container>
  </div>
  <div><label class="left">version: </label>
    <span [class]="firmwareVersionClass()">{{hub.swversion | version}} / {{hub.wifi_version | version}}
      <span *ngIf="!!upgradeVersion; else noupgrade">Upgrade to: {{upgradeVersion}}</span>
      <ng-template #noupgrade>Up to date.</ng-template>
    </span>
  </div>
  <div><label class="left">activity: </label>gap: {{hub.interval}}, wake secs: {{hub.avg_wake_secs}}, up:
    {{hub.uptime | humaninterval}}</div>
  <ng-container *ngIf="SameOrNewerThan(0,9,18)">
    <div *ngIf="!editable" (click)="edit()" class="editable">
      <label class="left">flags: </label>Duty Cycle: {{hubState.duty_cycle ? "On" : "Off"}},
      Time Shaving: {{hubState.time_shaving ? "On" : "Off"}},
      Peak Suppression: {{hubState.peak_temp_suppression ? "On" : "Off"}}
    </div>
    <div div *ngIf="editable" class="editable">
      <div class="editrow" id="smart_tech_editrow">
        <mat-form-field id="mat_smart_tech">
          <mat-select class="form-control" id="duty_cycle" required placeholder="Duty Cycle"
            [(ngModel)]="hubState.duty_cycle" name="duty_cycle_status">
            <mat-option [value]=true>On</mat-option>
            <mat-option [value]=false>Off</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field id="mat_smart_tech">
          <mat-select class="form-control" id="time_shaving" required placeholder="Time Shaving"
            [(ngModel)]="hubState.time_shaving" name="time_shaving_status">
            <mat-option [value]=true>On</mat-option>
            <mat-option [value]=false>Off</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field id="mat_smart_tech">
          <mat-select class="form-control" id="peak_temp_suppression" required placeholder="Peak Time Suppression"
            [(ngModel)]="hubState.peak_temp_suppression" name="peak_temp_suppression_status">
            <mat-option [value]=true>On</mat-option>
            <mat-option [value]=false>Off</mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-raised-button id="smart_tech_button" (click)="cancel()">Cancel</button>
        <button mat-raised-button id="smart_tech_button" color="primary" (click)="updateSmartTech()">Save</button>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-template #loading>Loading...</ng-template>